import {useEffect, useMemo, useRef, useState} from "react"
import showMessage from "../components/showMessage";
import { useReactiveVar } from "@apollo/client";
import { filterStates } from "./AppApolloProvider";
import { useFirebaseApp } from "contexts/FirebaseApp";

const translateEvent = (v: KV, title: string = "公開枠"): CalendarOpeningEvent => {
  return ({
    id: v._id, title: title, week: v.weekday, start: v.start, end: v.end, resourceId: v.modality || v.modalityID, extendedProps: {
      id: v._id, modality: v.modality, start: v.start, end: v.end, week: v.weekday, close: v.close, doctor: v.doctor, doctorID: v.doctorID
    }
  })
}

export const useFindOpeningTimes = (isModalOpen?: boolean, load?: boolean) => {
  const { functions } = useFirebaseApp()
  const [result, setResult] = useState<{ data?: CalendarOpeningEvent[] | null, loading?: boolean, error?: Error | null, refetch?: () => Promise<void> }>({
    data: null,
    loading: false,
    error: null,
  })
  const eventsReference = useRef<CalendarOpeningEvent[] | null | undefined>([])
  eventsReference.current = result.data

  useEffect(() => {
    async function fetchData() {
      setResult({
        loading: true,
        data: null,
        error: null,
      });
      try {
        const data: KV = await functions(["mongo/client", { collection: "opening_times", find: { filter: { weekday: { $in: [1,2,3,4,5,6,7] }}}}]) as KV[];
        setResult({
          data: data.map((v: KV) => translateEvent(v)),
          loading: false,
          error: null,
          refetch: fetchData
        });
      } catch (err) {
        setResult({
          data: null,
          loading: false,
          error: (err instanceof Error) ? err : null,
        });
      }

    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen, load]) // initially db is null
  return result
}


export const useFindOpeningDailyTimes = (isModalOpen?: boolean, load?: boolean) => {
  const { functions } = useFirebaseApp()
  const values: KV = useReactiveVar(filterStates)
  const dateRange = useMemo(() => values?.externalDaily || { start: new Date(), end: null }, [values])

  const [result, setResult] = useState<{ data?: CalendarOpeningEvent[] | null, loading?: boolean, error?: Error | null, refetch?: () => Promise<void> }>({
    data: null,
    loading: false,
    error: null,
  })
  const eventsReference = useRef<CalendarOpeningEvent[] | null | undefined>([])
  eventsReference.current = result.data

  useEffect(() => {
    async function fetchData() {
      setResult({
        loading: true,
        data: null,
        error: null,
      });
      try {
        const data: KV = await functions(["mongo/client", { collection: "opening_times", find: { filter: { weekday: { $in: [99] }, start: { $gte: dateRange.start, $lt: dateRange.end } } } }]) as KV[];
        const data2: KV = await functions(["mongo/client", { collection: "bookings", find: { filter: { modalityID: { $in: ['MRI', 'PET-CT_1', 'PET-CT_2']}, bookingStatus: { $ne: 5 }, start: { $gte: dateRange.start, $lt: dateRange.end } } } }]) as KV[];
        setResult({
          data: data.map((v: KV) => translateEvent(v)).concat(data2.map((v: KV) => ({ ...translateEvent(v, '予約済'),  display: "background" }))),
          loading: false,
          error: null,
          refetch: fetchData
        });
      } catch (err) {
        setResult({
          data: null,
          loading: false,
          error: (err instanceof Error) ? err : null,
        });
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen, load, dateRange]) // initially db is null
  return result
}